export default function Intro() {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          {/* Content */}
          <div>
            <div className="mb-4">
              <span className="text-teal-600 text-sm font-bold uppercase tracking-wider">Về Chúng Tôi</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Đơn Vị Thu Mua<br />
              Phế Liệu, Uy Tín<br />
              Hàng Đầu Khu Vực
            </h2>

            <div className="space-y-4 mb-8">
              <p className="text-gray-700 text-base leading-relaxed">
                Công ty TNHH Phế Liệu Nam Phát tự hào là đơn vị thu mua phế liệu uy tín với hơn 15 năm kinh nghiệm trong ngành. Chúng tôi sở hữu đội ngũ nhân viên chuyên nghiệp, được đào tạo bài bản, luôn sẵn sàng phục vụ khách hàng 24/7 với thái độ nhiệt tình và tận tâm.
              </p>
              <p className="text-gray-700 text-base leading-relaxed">
                Cam kết mang đến mức giá thu mua cao nhất thị trường, quy trình làm việc nhanh chóng, minh bạch. Nam Phát không chỉ tạo giá trị kinh tế cho khách hàng mà còn đóng góp tích cực vào công tác bảo vệ môi trường, tái chế và tái sử dụng tài nguyên một cách hiệu quả.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-8">
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
                <div className="text-4xl font-bold text-amber-500 mb-2">15+</div>
                <div className="text-sm text-gray-600">Năm Kinh Nghiệm</div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
                <div className="text-4xl font-bold text-amber-500 mb-2">5000+</div>
                <div className="text-sm text-gray-600">Khách Hàng Tin Dùng</div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
                <div className="text-4xl font-bold text-amber-500 mb-2">100%</div>
                <div className="text-sm text-gray-600">Hài Lòng</div>
              </div>
            </div>

            <a href="#services" className="inline-flex items-center gap-3 bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 rounded-full text-sm font-bold transition-all whitespace-nowrap">
              TÌM HIỂU THÊM
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-lg"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
